import {
  faArrowTrendUp,
  faBuilding,
  faCoins,
  faArrowRightArrowLeft,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useNavigate } from 'react-router-dom';
import cn from 'classnames';
import { getEntityLink } from 'helpers/getEntityLink';
import { MoneyAmount } from 'components/MoneyAmount';
import { Button } from 'components/Button';
import styles from './Hero.scss';

export const Hero = ({ mainCashbox, handleTransferOpen }) => {
  const navigate = useNavigate();

  return (
    <div className={styles.card} onClick={() => navigate(getEntityLink(`finance/${mainCashbox.id}`))}>
      <div className={styles.decoration} />
      <div className={cn(styles.decoration, styles.small)} />

      <div className={styles.content}>
        <div className={styles.header}>
          <div className={styles.info}>
            <div className={styles.icon}>
              <FontAwesomeIcon icon={faBuilding} />
            </div>
            <div className={styles.text}>
              <h2 className={styles.title}>{mainCashbox.name}</h2>
              <p className={styles.subtitle}>Головний рахунок</p>
            </div>
          </div>
          <div className={styles.actions}>
            <Button
              className={styles.actionBtn}
              title='Швидкий переказ з цього рахунку'
              onClick={(e) => handleTransferOpen(e, mainCashbox)}
              noStyle
            >
              <FontAwesomeIcon icon={faArrowRightArrowLeft} />
            </Button>
          </div>
        </div>

        <div className={styles.balance}>
          <FontAwesomeIcon icon={faCoins} className={styles.balanceIcon} />
          <span className={styles.balanceAmount}>
            <MoneyAmount value={mainCashbox.balance} />
          </span>
        </div>

        <div className={styles.stats}>
          {/* <span className={styles.stat}>
          <FontAwesomeIcon icon={faArrowTrendUp} />
          +12% за місяць
        </span> */}
          {/* <span className={styles.statDivider}>•</span> */}
          <span className={styles.stat}>Остання операція: сьогодні</span>
        </div>
      </div>
    </div>
  );
};
